/**
 * Module « Travaux du jour » — décision Dove 09/09 : les travaux du jour ont
 * leur propre page, sortie du tableau de bord (bible §17). Placé entre
 * Tableau de bord (10) et À relancer (20).
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "travaux-du-jour",
  label: "Travaux du jour",
  icon: "i-cal",
  navGroup: "pilotage",
  navOrder: 15,
  rolesRequis: [],
  routes: [{ path: "/travaux-du-jour", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
